import {createSlice} from "@reduxjs/toolkit";

import {getBadge, createBadge, updateBadge, deleteBadge} from "./thunk";

export const initialState = {
    badge: [],
    errors: {}
};

const BadgeSlice = createSlice({
    name: 'Badge',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getBadge.fulfilled, (state: any, action: any) => {
            state.badge = action.payload;
        });
        builder.addCase(getBadge.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(createBadge.fulfilled, (state: any, action: any) => {
            state.badge.unshift(action.payload);
        });
        builder.addCase(createBadge.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(updateBadge.fulfilled, (state: any, action: any) => {
            state.badge = state.badge.map((badge: any) =>
                badge.id === action.payload.id
                    ? {...badge, ...action.payload}
                    : badge
            );
        });

        builder.addCase(updateBadge.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteBadge.fulfilled, (state: any, action: any) => {
            state.badge = state.badge.filter(
                (badge: any) => badge.id !== action.payload
            );
            console.log(action.payload)
        });
        builder.addCase(deleteBadge.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default BadgeSlice.reducer;